import { ReferralResponse } from '../api/createReferral';
import { ReferralFormData } from '../context';
import { getFormName, logGAEvents } from './index';
import { navigateToResultsPage, waitForTracking } from '../../../shared/utils';
import { trackFormSubmitted } from '../../../shared/analytics';

async function handleReferralResponse(
  referralResponse: ReferralResponse,
  referral: ReferralFormData,
  partnerUrn: string
) {
  logGAEvents(referralResponse.request_key, referral);
  await waitForTracking(() =>
    trackFormSubmitted({
      trusted_referral_key: referralResponse.request_key,
      fan: {
        first_name: referral.first_name,
        last_name: referral.last_name,
        email: referral.email,
        phone_number: referral.phone,
        postal_code: referral.postal_code
      },
      form_name: getFormName()
    })
  );
  navigateToResultsPage(
    referralResponse.request_key,
    partnerUrn,
    undefined,
    undefined,
    referral.postal_code
  );
}

export { handleReferralResponse };
